exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/addtosubkeyword/addtosubkeyword.component.scss
// module id = ../../../../../src/app/main/content/addtosubkeyword/addtosubkeyword.component.scss
// module chunks = main